export default "__VITE_ASSET__B7D$c2Bn__"